import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import Profile from "./profile";

const ProfileModal = ({show, setShow}) => {
  return (
    <Modal
      className="profile-modal-container"
      show={show}
      onHide={() => setShow(!show)}
      dialogClassName="profile-modal"
      backdropClassName="profile-modal-backdrop"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Body>
        <Button onClick={() => setShow(!show)} className="close-profile-modal">retour <img alt="close" src="/icons/close.png" /></Button>
        <Profile setShow={setShow} />
      </Modal.Body>
    </Modal>
  )
}

export default ProfileModal;